(function (root) {
  'use strict';
  if (root.JEFamilyCart) return;
  root.JEFamilyCart = Object.freeze({
    tokenProperty: '_Family submission',
    payloadProperty: '_Family payload',
    create(config = {}) {
      if (!root.JEBirthflowerCart?.create) throw new Error('The cart tools did not load. Refresh the page to try again.');
      return root.JEBirthflowerCart.create({ ...config, kind: 'family' });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
